export const capitalise = (key) => `${key.charAt(0).toUpperCase()}${key.slice(1)}`;

export const asSingular = (key) => key.replace(/ies$/, 'y').replace(/s$/, '');
